import type { Rule } from "antd/lib/form";
import i18n from "i18next";

import type { ValidationRuleParams } from "../../../types/types";

export const getPatternRule = (validationRuleParams: ValidationRuleParams) => {
    if (!validationRuleParams || validationRuleParams.length === 0) {
        return undefined;
    }

    const PATTERN_ARG = 0;

    const regex = new RegExp(`^(?:${validationRuleParams[PATTERN_ARG] as string})$`);

    return {
        validator: (_, value) => {
            if (!value) {
                return Promise.resolve();
            }
            const testValue = `${value}`;
            let isValid = true;
            const lines = testValue.split("\n");
            lines.forEach((line: string) => {
                const values = line.split(",");
                values.forEach((v) => {
                    if (!regex.test(v)) {
                        isValid = false;
                    }
                });
            });

            return isValid
                ? Promise.resolve()
                : Promise.reject(i18n.t("common.input.pattern.error", { pattern: validationRuleParams[PATTERN_ARG] }));
        },
    } as Rule;
};
